<template>
  <div>
  <el-dialog :visible.sync="dialogVisible" width="900px" :show-close="false">
    <img
      class="close-img"
      alt="close-icon.png"
      @click="dialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="title">{{ $t("user_assets.web_record.recharge2") }}</p>
    
    <div class="exchange-rate">{{ bankInfo.exchangeRate || "1HK$ = 1HKD" }}</div>
    
    <div class="form-item">
      <label class="label">{{ $t("wallet.charging.amount") }}</label>
      <el-input 
        class="input"
        v-model="amount" 
        :placeholder="$t('wallet.charging.amount_placeholder')"
      />
    </div>
    
    <div class="account-section">
      <p class="section-title">{{ $t("wallet.charging.hkd_account") }}</p>
      <div class="account-box">
        <div class="account-item">
          <span class="label">{{ $t("wallet.charging.receive_account") }}</span>
          <span class="value">{{ bankInfo.receiveAccount }}</span>
          <img 
            src="@/assets/img/images/icon/copy.png" 
            alt="copy" 
            class="copy-icon"
            @click="copyText(bankInfo.receiveAccount)"
          />
        </div>
        <div class="account-item">
          <span class="label">{{ $t("wallet.charging.company") }}</span>
          <span class="value">{{ bankInfo.company }}</span>
          <img 
            src="@/assets/img/images/icon/copy.png" 
            alt="copy" 
            class="copy-icon"
            @click="copyText(bankInfo.company)"
          />
        </div>
        <div class="account-item">
          <span class="label">{{ $t("wallet.charging.bank") }}</span>
          <span class="value">{{ bankInfo.bankName }}</span>
          <img 
            src="@/assets/img/images/icon/copy.png" 
            alt="copy" 
            class="copy-icon"
            @click="copyText(bankInfo.bankName)"
          />
        </div>
      </div>
    </div>
    
    <div class="form-section">
      <p class="section-title">{{ $t("wallet.charging.bank_info") }}</p>
      <div class="form-item">
        <label class="label required">*</label>
        <label class="label">{{ $t("wallet.charging.transfer_account") }}</label>
        <el-input 
          class="input"
          v-model="transferForm.account" 
          :placeholder="$t('wallet.charging.input_placeholder')"
        />
      </div>
      <div class="form-item">
        <label class="label required">*</label>
        <label class="label">{{ $t("wallet.charging.name") }}</label>
        <el-input 
          class="input"
          v-model="transferForm.name" 
          :placeholder="$t('wallet.charging.input_placeholder')"
        />
      </div>
      <div class="form-item">
        <label class="label">{{ $t("wallet.charging.transaction_no") }}</label>
        <el-input 
          class="input"
          v-model="transferForm.transactionNo" 
          :placeholder="$t('wallet.charging.input_placeholder')"
        />
      </div>
    </div>
    
    <p class="submit-tip">{{ $t("wallet.charging.confirm_tip") }}</p>
    
    <el-button class="submit-btn" @click="submitTransfer">
      {{ $t("wallet.charging.complete") }}
    </el-button>
    
    <div class="tips-container">
      <p class="tip-item">*{{ $t("wallet.charging.tip1") }}</p>
      <p class="tip-item">*{{ $t("wallet.charging.tip2") }}</p>
      <p class="tip-item">*{{ $t("wallet.charging.tip3") }}</p>
    </div>
  </el-dialog>

  <el-dialog
    :visible.sync="submitDialogVisible"
    width="560px"
    :show-close="false"
    custom-class="hkd-submit-dialog"
  >
    <img
      class="submit-close"
      alt="close-icon.png"
      @click="submitDialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="submit-title">{{ $t("wallet.charging.submitted_title") }}</p>
    <p class="submit-desc">{{ $t("wallet.charging.submitted_desc") }}</p>
    <el-button class="record-btn" @click="viewDepositRecords">
      {{ $t("wallet.charging.view_records") }}
    </el-button>
  </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      dialogVisible: false,
      amount: "",
      transferForm: {
        account: "",
        name: "",
        transactionNo: "",
      },
      bankInfo: {
        receiveAccount: "",
        company: "",
        bankName: "",
        exchangeRate: "",
      },
      submitDialogVisible: false,
    };
  },
  computed: {
    ...mapState({
      user: "user",
      errorCode: "errorCode",
    }),
  },
  mounted() {},
  methods: {
    init() {
      this.dialogVisible = true;
      this.amount = "";
      this.transferForm = {
        account: "",
        name: "",
        transactionNo: "",
      };
      this.getHKDAccount();
    },
    getHKDAccount() {
      this.$axios
        .post("/userAssets/depositHKDAccount", {
          coinType: "HKD",
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.bankInfo = res.data.data;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    copyText(text) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          this.$message({
            type: "success",
            message: this.$t("tipsVal.copySucess"),
          });
        })
        .catch((err) => {
          this.$message({
            type: "warning",
            message: this.$t("tipsVal.copyerror"),
          });
        });
    },
    submitTransfer() {
      if (!this.amount) {
        this.$message({
          type: "warning",
          message: this.$t("wallet.charging.amount_required"),
        });
        return;
      }
      if (!this.transferForm.account) {
        this.$message({
          type: "warning",
          message: this.$t("wallet.charging.account_required"),
        });
        return;
      }
      if (!this.transferForm.name) {
        this.$message({
          type: "warning",
          message: this.$t("wallet.charging.name_required"),
        });
        return;
      }
      this.$axios
        .post("/userAssets/depositHKD", {
          coinType: "HKD",
          amount: this.amount,
          transferAccount: this.transferForm.account,
          transferName: this.transferForm.name,
          transactionNo: this.transferForm.transactionNo,
        })
        .then((res) => {
          if (res.data.code === this.errorCode.ok) {
            this.dialogVisible = false;
            this.submitDialogVisible = true;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    viewDepositRecords() {
      this.submitDialogVisible = false;
      this.$emit("view-deposit-records");
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 10px;
  .el-dialog__body {
    padding-top: 0;
    position: relative;
    padding: 30px;
  }
}

.close-img {
  top: 20px;
  right: 20px;
  width: 16px;
  height: 16px;
  cursor: pointer;
  position: absolute;
  z-index: 10;
}

.title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 24px;
  color: #333333;
  margin-bottom: 30px;
}

.exchange-rate {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  text-align: right;
  margin-bottom: 20px;
}

.form-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  
  .label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    width: 120px;
    min-width: 120px;
  }
  
  .required {
    color: #F04545;
    width: auto;
    min-width: auto;
    margin-right: 5px;
  }
  
  // .input {
  //   flex: 1;
  //   height: 44px;
  //   border-radius: 8px;
  //   border: 1px solid #e2e3e3;
  // }
}

.section-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #333333;
  margin-bottom: 15px;
}

.account-section {
  margin-bottom: 30px;
}

.account-box {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
}

.account-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px dashed #e2e3e3;
  
  &:last-child {
    border-bottom: none;
  }
  
  .label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    width: 120px;
    min-width: 120px;
  }
  
  .value {
    flex: 1;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #333333;
    word-break: break-all;
  }
  
  .copy-icon {
    width: 18px;
    height: 18px;
    cursor: pointer;
    margin-left: 15px;
    flex-shrink: 0;
  }
}

.form-section {
  margin-bottom: 20px;
}

.submit-tip {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  margin-bottom: 20px;
}

.submit-btn {
  width: 100%;
  height: 50px;
  background: linear-gradient(135deg, #4063ff 0%, #6b8cff 100%);
  border: none;
  border-radius: 10px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background: linear-gradient(135deg, #3053ee 0%, #5a7cff 100%);
  }
  
  &:active {
    transform: scale(0.98);
  }
}

.tips-container {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

.tip-item {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 1.8;
}

/deep/.el-input__inner {
  font-family: PingFang SC, PingFang SC;
  font-size: 14px;
}

/deep/.hkd-submit-dialog {
  border-radius: 0;
  .el-dialog__body {
    position: relative;
    padding: 56px 48px 64px;
    text-align: center;
  }
}

.submit-close {
  position: absolute;
  top: 28px;
  right: 28px;
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.submit-title {
  margin: 10px 0 34px;
  font-size: 34px;
  font-weight: 400;
  color: #333333;
}

.submit-desc {
  margin: 0 0 54px;
  font-size: 22px;
  line-height: 32px;
  color: #333333;
}

.record-btn {
  width: 310px;
  height: 70px;
  border: none;
  border-radius: 4px;
  background: #2f78ff;
  font-size: 24px;
  color: #ffffff;
  &:hover,
  &:focus {
    background: #2f78ff;
    color: #ffffff;
  }
}
</style>
